export function extend(type, extension) {
    return `${type}__${extension}`;
}

export function success(type) {
    return extend(type, 'SUCCESS');
}

export function fail(type) {
    return extend(type, 'FAIL');
}

export function show(type) {
    return extend(type, 'SHOW');
}

export function hide(type) {
    return extend(type, 'HIDE');
}

export function clean(type) {
    return extend(type, 'CLEAN');
}

export function progress(type) {
    return extend(type, 'PROGRESS');
}

export function cancel(type) {
    return extend(type, 'CANCEL');
}



// WEBPACK FOOTER //
// ./src/reducers/extendActionType.js